import { render } from "./recapTransfere.vue?vue&type=template&id=7bda9fc0&scoped=true"
import script from "./recapTransfere.vue?vue&type=script&lang=js"
export * from "./recapTransfere.vue?vue&type=script&lang=js"

import "./recapTransfere.vue?vue&type=style&index=0&id=7bda9fc0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bda9fc0"]])

export default __exports__